import { message } from "antd";
import { checkAuthorization } from "../../helpers";
import { domainUrl } from "../../constants";


const getMasterVendorLookup= ()=>{
    const {userToken} = checkAuthorization()
    var myHeaders = new Headers()
    myHeaders.append('Authorization', userToken)
    return (
        fetch(domainUrl + "/vendorDropDown", {
            method: "GET",
            headers: myHeaders
        })
        .then(response => response.json())
        .then(result => {
            if (result?.success) 
                return result?.vendor
            else
                throw result?.message
        })
        .catch(error => {
            message.error(error)
            return 0
        })
    )
}
const updateCreateApi = (formData) => {
    const {userToken} = checkAuthorization()
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append('Authorization', userToken);
    var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: JSON.stringify(formData),
        redirect: 'follow'
    };
    const url = formData.id ? `/updateAndroidBox` : '/createAndroidBox';
    return (
        fetch(domainUrl + url, requestOptions)
        .then(response => response.json())
        .then(result => {
            if (result?.success) {
                message.success(result?.message)
                return 1
            } else {
                message.error('Something went wrong');
                return 0
            }
        })
        .catch(error => {
            message.error(error.message || 'Something went wrong');
            return 0
        })
    )
};


const DeleteAndroidApi=(deletebox)=>{
    const {userToken} = checkAuthorization()
    var myHeaders = new Headers();
    myHeaders.append("Content-Type","application/json")
    myHeaders.append('Authorization', userToken);
    var requestOptions = {
      method:'DELETE',
      headers: myHeaders,
      redirect:'follow'
    }
    return(
        fetch(domainUrl + `/deleteAndroidBox/${deletebox}`, requestOptions)
        .then(response => response.json())
        .then(result => {
            if (result?.success) {
                message.success(result?.message)
            } 
            else 
                throw result?.message
        })
        .catch(error => {
            message.error(error.message || 'Something went wrong');
        })
    )
  }


const addBoxApi = {
    getMasterVendorLookup,
    updateCreateApi,
    DeleteAndroidApi
}

export {addBoxApi}
